<template>
    <div v-if="isLandscape" class="return-items-cart-landscape">
        <b-row class="mb-4 justify-content-between align-items-center">
            <b-col sm="9" xl="10">
                <b-row>
                    <b-col>
                        <h5>
                            <img class="mr-2" :src="require('../../assets/user.svg')" alt="Logo">
                            <strong>
                                {{ selectedKioskConsumer.firstname }} {{ selectedKioskConsumer.lastname }}
                            </strong>
                        </h5>
                    </b-col>
                </b-row>
                <b-row class="d-flex justify-content-between flex-row">
                    <b-col class="float-left">
                        CREDIT: <strong>€ {{ selectedKioskConsumer.coefficient }}</strong>
                    </b-col>
                </b-row>
            </b-col>
            <b-col class="text-right">
                <img class="history-icon" :src="require('../../assets/history_icon.svg')" alt="Order History">
            </b-col>
        </b-row>
        <b-row class="mt-4 cart-items">
            <b-col class="mb-3">
                <h5>
                    <strong>Rückgabe:</strong>
                </h5>
            </b-col>
            <ol class="w-100">
                <li v-for="(cartItem, index) in cart" :key="index">
                    <b-row class="mb-4">
                        <b-col cols="7">
                            <div>{{ cartItem.name }}</div>
                            <div>{{ formatPrice(cartItem.price) }} €</div>
                            <div v-for="(deposit, depositIndex) in cartItem.deposits" :key="depositIndex">
                                <div>{{ deposit.name }}</div>
                                <div>
                                    {{ formatPrice(deposit.price) }} €
                                    <img class="ml-1" :src="require('../../assets/recycle.svg')" alt="Deposit">
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="5">
                            <b-row>
                                <img
                                    :src="require('../../assets/minus_button.svg')"
                                    alt="Decrease"
                                    @click="decrease(index)"
                                >
                                <div class="mr-2 ml-2 d-flex justify-content-center flex-column">
                                    {{ cartItem.quantity }}
                                </div>
                                <img
                                    :class="{'disabled':isIncreaseBtnDisabled(index)}"
                                    :src="require('../../assets/plus_button.svg')"
                                    alt="Increase"
                                    @click="increase(index)"
                                >
                            </b-row>
                        </b-col>
                    </b-row>
                </li>
            </ol>
        </b-row>
        <div class="buttons">
            <b-row class="mt-5" v-if="cart.length > 0">
                <b-col>
                    <h5>
                        <strong>Rückerstattung: {{ getCartTotalPrice(cart).toFixed(2) }} €</strong>
                    </h5>
                </b-col>
            </b-row>

            <b-row class="d-flex justify-content-center flex-row mt-3">
                <b-col>
                    <b-button
                        v-if="cart.length > 0"
                        class="submit-button"
                        variant="primary"
                        block
                        :disabled="disabled"
                        @click="createReturn"
                    >
                        Einreichen
                    </b-button>
                    <b-button class="cancel-button" id="cancel-button-bottom" block @click="cancel">
                        Stornieren
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </div>

    <div v-else class="return-items-cart-portrait">
        <b-row>
            <b-col cols="5">
                <b-row>
                    <b-col cols="9">
                        <h5>
                            <img :src="require('../../assets/user.svg')" alt="Logo" class="mr-2">
                            <strong>
                                {{ selectedKioskConsumer.firstname }} {{ selectedKioskConsumer.lastname }}
                            </strong>
                        </h5>
                    </b-col>
                    <b-col>
                        <img
                            class="history-icon"
                            :src="require('../../assets/history_icon.svg')"
                            alt="Order history"
                        >
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="3">CREDIT: <strong>€ {{ selectedKioskConsumer.coefficient }}</strong></b-col>
            <b-col class="d-flex justify-content-end flex-row" v-if="cart.length > 0">
                <h5>
                    <strong>Rückerstattung: {{ getCartTotalPrice(cart).toFixed(2) }} €</strong>
                </h5>
            </b-col>
        </b-row>

        <b-row class="mt-3">
            <b-col>
                <b-row>
                    <b-col class="mb-3">
                        <h5>
                            <strong>Rückgabe:</strong>
                        </h5>
                    </b-col>
                </b-row>
                <b-row v-for="(cartItem, index) in cart" :key="index" class="mb-2">
                    <b-col cols="1">
                        {{ index + 1 }}.
                    </b-col>
                    <b-col cols="5">
                        <div>{{ cartItem.name }}</div>
                        <div>{{ formatPrice(cartItem.price) }} €</div>
                        <div v-for="(deposit, depositIndex) in cartItem.deposits" :key="depositIndex">
                            <div>{{ deposit.name }}</div>
                            <div>
                                {{ formatPrice(deposit.price) }} €
                                <img class="ml-1" :src="require('../../assets/recycle.svg')" alt="Deposit">
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="3">
                        <b-row>
                            <img
                                :src="require('../../assets/minus_button.svg')"
                                alt="Decrease"
                                @click="decrease(index)"
                            >
                            <div class="mr-2 ml-2 d-flex justify-content-center flex-column">
                                {{ cartItem.quantity }}
                            </div>
                            <img
                                :class="{'disabled':isIncreaseBtnDisabled(index)}"
                                :src="require('../../assets/plus_button.svg')"
                                alt="Increase"
                                @click="increase(index)"
                            >
                        </b-row>
                    </b-col>
                    <b-col>
                        {{ getCartItemTotalPrice(cartItem).toFixed(2) }} €
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="3">
                <b-button
                    v-if="cart.length > 0"
                    variant="primary"
                    class="submit-button"
                    block
                    :disabled="disabled"
                    @click="createReturn"
                >
                    Einreichen
                </b-button>
                <b-button class="cancel-button" id="cancel-button-right" block @click="cancel">
                    Stornieren
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import cartMixin    from "@/mixins/cartMixin";
import {mapGetters} from "vuex";

export default {
    name:     "ReturnItemsCart",
    mixins:   [cartMixin],
    props:    {
        isLandscape: {
            type:    Boolean,
            default: true,
        },
        cart:        Array,
        disabled:    Boolean,
    },
    computed: {
        ...mapGetters(['selectedKioskConsumer']),
    },
    methods:  {
        formatPrice(price) {
            return parseFloat(price).toFixed(2);
        },
        isIncreaseBtnDisabled(index) {
            return (this.cart[index].quantity + 1) > this.cart[index].returnable_quantity;
        },
        decrease(index) {
            return this.$emit('decrease', index);
        },
        increase(index) {
            return this.$emit('increase', index);
        },
        createReturn() {
            return this.$emit('return');
        },
        cancel() {
            return this.$emit('cancel');
        },
    }
}
</script>

<style lang="scss">
.return-items-cart-landscape,
.return-items-cart-portrait {
    .disabled {
        opacity: .5;
    }
}
</style>